import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { Callout } from './callout.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const ActivityChild = Type.Object({
    tsgId: Type.String({ minLength: 1 }),
    key: Type.String({ minLength: 1 })
});
export const ActivityDimension = Type.Object({
    id: Type.String({ minLength: 1 }),
    domainId: Type.String({ minLength: 1 }),
    code: Type.String({ minLength: 1 }),
    description: Type.String()
});
export const TeachActivityResourceTypes = {
    mightyMinute: 'mm',
    ITE: 'ite',
    kaEssentialAlphabet: 'ka_essential_alphabet',
    kaEssentialNumbers: 'ka_essential_numbers',
    custom: 'CustomResource',
    SDC: 'SDC',
    unknown: 'unknown'
};
export const TeachActivityResourceType = Type.Union([
    Type.Literal(TeachActivityResourceTypes.mightyMinute),
    Type.Literal(TeachActivityResourceTypes.ITE),
    Type.Literal(TeachActivityResourceTypes.kaEssentialAlphabet),
    Type.Literal(TeachActivityResourceTypes.kaEssentialNumbers),
    Type.Literal(TeachActivityResourceTypes.custom),
    Type.Literal(TeachActivityResourceTypes.SDC),
    Type.Literal(TeachActivityResourceTypes.unknown)
]);
export const TeachActivityResourceTypeCodec = createFallbackStringEnumCodec(TeachActivityResourceTypes, TeachActivityResourceTypes.unknown);
export const ResourceReference = Type.Object({
    id: Type.Optional(Type.String({ minLength: 1 })),
    code: Type.String({ minLength: 1 }),
    type: TeachActivityResourceTypeCodec
});
export const DimensionIdentifier = Type.Object({
    id: Type.String({ minLength: 1 }),
    code: Type.String({ minLength: 1 })
});
export const DimensionReference = Type.Object({
    identifier: DimensionIdentifier,
    references: Type.Array(ResourceReference)
});
export const TeachActivityMetadata = Type.Object({
    assetCode: Type.String({ minLength: 1 }),
    assetType: TeachActivityResourceTypeCodec,
    childIds: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
    assessedChildIds: Type.Optional(Type.Array(Type.String({ minLength: 1 })))
});
export const FinchGame = Type.Object({
    gameID: Type.Optional(Type.String({ minLength: 1 }))
});
export const Facilitation = Type.Object({
    callouts: Type.Array(Callout),
    guidance: Type.Optional(Type.String()),
    title: Type.String(),
    vocabularyTitle: Type.Optional(Type.String()),
    vocabulary: Type.String(),
    finchGame: Type.Optional(FinchGame)
});
export const ObservationQuestions = Type.Object({
    title: Type.Optional(Type.String()),
    content: Type.Optional(Type.String())
});
export const TeachActivityEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.teachActivity),
        metadata: Type.Optional(Type.Array(TeachActivityMetadata)),
        activityType: Type.String({ minLength: 1 }),
        timeOfDayId: Type.Integer(),
        orderNum: Type.Number(),
        studyId: Type.Optional(Type.String({ minLength: 1 })),
        childCount: Type.Optional(Type.Integer()),
        children: Type.Array(ActivityChild),
        activityName: Type.Optional(Type.String()),
        activityTitle: Type.Optional(Type.String()),
        subtitle: Type.Optional(Type.String()),
        content: Type.Optional(Type.String()),
        description: Type.Optional(Type.String()),
        facilitation: Type.Optional(Type.Array(Facilitation)),
        observeReflectRespond: Type.Optional(Type.String()),
        observeReflectRespondTitle: Type.Optional(Type.String()),
        dimensions: Type.Array(ActivityDimension),
        primaryDimensionReferences: Type.Optional(Type.Array(DimensionReference)),
        relatedDimensionReferences: Type.Optional(Type.Array(DimensionReference)),
        observationQuestions: Type.Optional(ObservationQuestions),
        materialsString: Type.Optional(Type.String()),
        isSystemCreated: Type.Boolean(),
        isSmartTeach: Type.Boolean(),
        hasDocument: Type.Boolean(),
        hasFamily: Type.Boolean(),
        experienceFl: Type.Boolean(),
        activityId: Type.Optional(Type.String({ minLength: 1 }))
    })
]));
